(function($){

    var form = $('.c37-lp form input');

    if (form.length > 1)
        form.parsley();

})(jQuery);